export default {"src":"/_next/static/media/syk.366d549a.svg","height":20,"width":20};